import { Button, Stack, Typography } from '@mui/material'
import { KittySvg } from './KittySvg'
import { LaserSvg } from './LaserSvg'
import { OopsSvg } from './OopsSvg'
import { i18WithDefault as t } from '@shared/locale'

export const NotFound = () => {
  return (
    <>
      <OopsSvg
        style={{
          position: 'absolute',
          top: '240px',
          left: 'calc(450px + 15%)',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <KittySvg
        style={{
          position: 'absolute',
          top: '400px',
          left: 'calc(800px + 15%)',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <LaserSvg
        style={{
          position: 'absolute',
          top: '135px',
          left: 'calc(535px + 15%)',
          transform: 'translate(-50%, -50%)',
        }}
      />
      <Stack
        spacing={4}
        alignItems="center"
        sx={{
          width: 450,
          textAlign: 'center',
          position: 'absolute',
          top: 'calc(350px + 15%)',
          left: 'calc(430px + 15%)',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Typography variant="h4">{t('global.notFound')}</Typography>
        <Button variant="contained" color="success">
          {t('global.notFound.tryAgain')}
        </Button>
      </Stack>
    </>
  )
}
